import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import logo from "../../../assets/images/logo/ksijLogo2x.png";
import "assets/css/appLoader.css";

const AppLoader = forwardRef((_, ref) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoader = (loading) => {
    setIsLoading(loading);
  };

  useEffect(() => {
    if (isLoading) {
      document.body.classList.add("scroll-lock");
    } else {
      document.body.classList.remove("scroll-lock");
    }
  }, [isLoading]);

  useImperativeHandle(ref, () => ({ showLoader }), []);

  if (isLoading) {
    return (
      <div className="reload-page-style">
        <img src={logo} className="logo-image" alt="" />
      </div>
    );
  }

  return null;
});

export default AppLoader;
